export default class StickyBanner {
    constructor(elem, context) {
        if (!elem || !context) {
            throw new Error('Element and context required to initialize object');
        }
        this.$elem = $(elem);
        this.$bannerDIV = this.$elem.children().first()
        this.$context = $(context);
        this._onScroll();
    }

    _onScroll() {
        var $bannerDIV = this.$bannerDIV;
        var $elem = this.$elem;
        var gapY = 16;

        this.$context.on('scroll', function() {
          var height = $bannerDIV.height();
          $elem.height(height);
          var top = $elem.get(0).getBoundingClientRect().top;
          if(top - gapY <=0 ) {
                $bannerDIV.css({ position: "fixed", "z-index": 9999, top: gapY + "px" });
           } else {
                $bannerDIV.css({ position: "", "z-index": "", top: "" });
           }
        });
    }

}
